// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_25U5z"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/dpa/dpa.scss
 ** module id = 468
 ** module chunks = 0
 **/